/* nt-fx-instalador-capa.js: quadro do navegador na capa do instalador (sections/nt-fx-instalador-capa.liquid).
   1. compatibilidade: grava pelo cabo quem tem web serial (chrome, edge e opera no computador) ou webusb
      (chrome no android, pelo adaptador do instalador). o resultado vai em data-estado="ok|nao" e troca o texto.
   2. versao mais recente: le o campo "versao" do arquivo de versao (o mesmo da verificacao do instalador).
      enquanto le, a linha guarda o lugar invisivel (data-estado so chega com o numero); sem rede ou sem o campo,
      ela some de vez. */
(function () {
  'use strict';

  var compativel = 'serial' in navigator || 'usb' in navigator;

  function compat(raiz) {
    var el = raiz.querySelector('[data-nt-compat]');
    if (!el) return;
    var texto = el.querySelector('[data-nt-compat-texto]');
    var msg = el.getAttribute(compativel ? 'data-ok' : 'data-nao');
    if (texto && msg) texto.textContent = msg;
    el.setAttribute('data-estado', compativel ? 'ok' : 'nao');
  }

  function versao(raiz) {
    var el = raiz.querySelector('[data-nt-versao]');
    if (!el) return;
    var num = el.querySelector('[data-nt-versao-num]');
    var fonte = el.getAttribute('data-fonte');
    function some() { el.hidden = true; }
    if (!num || !fonte || !window.fetch) return some();
    fetch(fonte, { cache: 'no-cache' })
      .then(function (r) {
        if (!r.ok) throw new Error('versao ' + r.status);
        return r.json();
      })
      .then(function (dados) {
        var v = String((dados && dados.versao) || '').trim();
        if (!v) return some();
        num.textContent = /^v/i.test(v) ? v : 'v' + v;
        el.setAttribute('data-estado', 'ok');
      })
      .catch(some);
  }

  function iniciar(raiz) {
    if (raiz.hasAttribute('data-nt-capa-pronta')) return;
    raiz.setAttribute('data-nt-capa-pronta', '');
    compat(raiz);
    versao(raiz);
  }

  function todas() {
    document.querySelectorAll('[data-nt-fx="instalador-capa"]').forEach(iniciar);
  }

  todas();
  // editor de temas: a secao volta redesenhada sem recarregar a pagina
  document.addEventListener('shopify:section:load', todas);
})();
